import { render } from "./SchoolEdit.vue?vue&type=template&id=d40262ba&scoped=true&ts=true"
import script from "./SchoolEdit.vue?vue&type=script&lang=ts"
export * from "./SchoolEdit.vue?vue&type=script&lang=ts"

import "./SchoolEdit.vue?vue&type=style&index=0&id=d40262ba&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40262ba"]])

export default __exports__